export const getQueryParamsFromUrl = (url?: string) => {
    const newUrl = new URL(url || window.location.toString());
    return new URLSearchParams(newUrl.search.slice(1));
  };
